(() => {
  const SCROLL_SHELL_CLASS = 'template-blog__tag-navigation__scroll-shell--scroll';

  class BlogTagNavigation extends HTMLElement {
    connectedCallback() {
      this.shell = this.querySelector('.template-blog__tag-navigation__scroll-shell');
      this.list = this.querySelector('.template-blog__tag-navigation__grid-list');
      if (!this.shell || !this.list) return;

      this._onResize = () => {
        if (this._raf) cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => {
          this._raf = null;
          this.update();
        });
      };

      this._resizeObserver = new ResizeObserver(this._onResize);
      this._resizeObserver.observe(this.shell);
      window.addEventListener('resize', this._onResize);

      requestAnimationFrame(() => requestAnimationFrame(() => this.update()));
    }

    disconnectedCallback() {
      this._resizeObserver?.disconnect();
      window.removeEventListener('resize', this._onResize);
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    getRowCount() {
      const tops = [];

      for (const item of this.list.children) {
        const top = item.offsetTop;
        if (!tops.some((value) => Math.abs(value - top) <= 1)) tops.push(top);
      }

      return tops.length;
    }

    update() {
      this.shell.classList.remove(SCROLL_SHELL_CLASS);

      if (this.getRowCount() > 1) {
        this.shell.classList.add(SCROLL_SHELL_CLASS);
      }
    }
  }

  if (!customElements.get('blog-tag-navigation')) {
    customElements.define('blog-tag-navigation', BlogTagNavigation);
  }
})();
